import React, { Component } from "react";
import PropTypes from "prop-types";

const withAnimation = (WrappedComponent) => {
  class _AnimatedComponent extends Component {
    state = {
      mount: this.props.mount,
      inProgress: this.props.mount && this.props.animateOnLoad,
      blockAnimation: !this.props.animateOnLoad,
    };

    static getDerivedStateFromProps(props, state) {
      if (!state.blockAnimation && props.mount !== state.mount) {
        return {
          inProgress: true,
          mount: props.mount,
        };
      }

      return null;
    }

    constructor(props) {
      super(props);
      this.wrapperRef = React.createRef();
      this._isMounted = false;
    }

    componentDidMount() {
      this.setState({
        blockAnimation: false,
      });
      this._isMounted = true;
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    shouldComponentUpdate(nextProps, nextState) {
      return this.state.blockAnimation === nextState.blockAnimation;
    }

    onAnimationEnd = (event) => {
      const { target } = event;
      const { current } = this.wrapperRef;

      if (target === current && this._isMounted) {
        this.setState({
          inProgress: false,
        });
      }
    };

    render() {
      const { mount, inProgress, blockAnimation } = this.state;
      const animationClass = mount
        ? "rof-transition--in"
        : "rof-transition--out";

      return inProgress || mount ? (
        <div
          ref={this.wrapperRef}
          className={`${!blockAnimation ? animationClass : ""}`}
          onAnimationEnd={this.onAnimationEnd}
        >
          <WrappedComponent {...this.props} />
        </div>
      ) : null;
    }
  }

  _AnimatedComponent.defaultProps = {
    animateOnLoad: true,
  };

  _AnimatedComponent.propTypes = {
    mount: PropTypes.bool,
    animateOnLoad: PropTypes.bool,
  };

  return _AnimatedComponent;
};

export default withAnimation;
